import React, { useContext, useEffect, useRef } from 'react';
import { MapIframe, MapMessageType, RoofSegment, SegmentIdMessage, SegmentIdsMessage } from '../../services/MapIframe';
import { MapIFrameContext } from '../../App';
import CheckboxToggle from './CheckboxToggle';
import { CalculatorUtil } from '../../services/CalculatorUtil';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

function RoofSide({ segment, index }: { segment: RoofSegment, index: number }) {

    const selectedCss = segment.selected ? 'bg-gray-100' : ''
    const errorMessage = segment.message ? <p className={'text-red-600 pt-3'}><ExclamationTriangleIcon className="inline h-6 w-6" /> {segment.message}</p> : <></>;

    const details = segment.selected ?
        <div className={'mt-2 text-sm'}>
            <p>Tilt: {segment.tilt}°</p>
            <p>Direction: {segment.azimuth}°</p>
            {errorMessage}
        </div>
        : <></>

    const mapContext = useContext(MapIFrameContext);
    const handleSegmentClick = () => {
        if (mapContext) {
            MapIframe.post(mapContext, {
                segmentId: segment.id,
                type: MapMessageType.SELECT_SEGMENT,
            } as SegmentIdMessage);
        }
    };

    const segmentRef = useRef<HTMLLIElement>(null);

    useEffect(() => {
        if (segment.selected) {
            segmentRef.current?.scrollIntoView({behavior: "smooth"});
        }
    }, [segment.selected])

    const handleCartClick = () => {
        if (mapContext) {
            MapIframe.post(mapContext, {
                segmentIds: [segment.id],
                type: segment.inCart ? MapMessageType.REMOVE_FROM_CART : MapMessageType.ADD_TO_CART,
            } as SegmentIdsMessage);
        }
    };

    return <li ref={segmentRef} key={'segment_' + index} onClick={handleSegmentClick} className="my-px">
        <div className={selectedCss + ' items-center px-4 py-2 rounded-lg text-gray-600 hover:bg-gray-100'}>
            <div className={'flex items-center'}>
                <div className={(segment.selected ? 'font-bold' : '') + ' min-w-24'}>Roof side {index}</div>
                <div className="text-gray-400 text-sm">{CalculatorUtil.formatNumber(segment.area3DM2)} m<sup>2</sup></div>
                <div className={'flex ml-auto'}>
                    <CheckboxToggle checked={!!segment.inCart} onChange={handleCartClick} ></CheckboxToggle>
                </div>
            </div>
            {details}
        </div>
    </li>;
}

export default RoofSide;